import { ref } from 'vue';
import Request from '@/services/request';
import { CATEGORY_COMMISSION_CAMPAIGNS_JOIN_BY_PROMO_CODE } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCategoryCommissionCampaignsJoinByPromoCode() {
  const isSubmitting = ref(false);

  const joinCampaign = async (promoCode) => {
    if (isSubmitting.value) return { success: false };

    isSubmitting.value = true;

    try {
      const response = await Req.post(
        CATEGORY_COMMISSION_CAMPAIGNS_JOIN_BY_PROMO_CODE,
        { promoCode: promoCode.trim() },
        { baseURL: '/sellerofficeapi/rest' },
      );

      return {
        success: response?.data?.success || false,
        data: response?.data,
        error: null,
      };
    } catch (error) {
      const errors = error?.data?.errors || [];
      const firstError = errors[0] || {};

      return {
        success: false,
        data: null,
        error: {
          title: firstError?.title || 'Hata',
          message: firstError?.message || 'Bir hata oluştu.',
          code: firstError?.code || null,
          campaignId:
            firstError?.detail?.campaignId || firstError?.campaignId || null,
        },
      };
    } finally {
      isSubmitting.value = false;
    }
  };

  return {
    isSubmitting,
    joinCampaign,
  };
}
